module.exports = __webpack_public_path__ + "img/11_26@2x.e2370d04.png";